import React, { useContext, useState, useEffect } from 'react';
import { Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Button } from '@mui/material';
import { SchoolContex } from '../../Helper/Contex';
import api from '../../API/api';
import FormDialog from '../modal/modal';
import { useNavigate } from 'react-router-dom'
import AddBlogForm from '../../AdminPages/form/addBlogForm';
import Loader from '../../AdminPages/panel/loader';


const htmlToFormattedText = require("html-to-formatted-text");

const Blogs = () => {
    const { schools, courses } = useContext(SchoolContex)
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const [blogs, setBlogs] = useState();
    const [load, setLoad] = useState(false)

    const handleClickOpen = e => setOpen(true)
    const handleClose = e => setOpen(false)


    useEffect(() => {
        getBlogs()

    }, [])

    const getBlogs = () => {
        setLoad(true)
        api.getBlogs().then((res) => {
            // console.log(res);
            setLoad(false)
            setBlogs(res.data.blogs.filter((el)=>el.isActive === 1))
        })
            .catch((err) => {
                setLoad(false)
                // console.log(err.response);
            })
    }


    return (
        <>
        {load && <Loader />}
            <div className='my-2'>
                <div className="row m-0 p-0">   
                    <div className="col-md-8">
                        <Paper elevation={3}>
                            <div className='d-flex justify-content-between p-md-3 p-2'>
                                <h3 className=''>Blogs   </h3>
                                {/* <button onClick={() => setOpen(true)} className='btn btn-primary' type='button'>+ Add Blogs</button> */}

                                <button onClick={() => navigate('/StudentLogin', {state : {from: 'blog'}}) } className='btn btn-primary' type='button'>+ Add Blogs</button>
                            </div>
                            <FormDialog form={<AddBlogForm handleClose={handleClose} handleClickOpen={handleClickOpen} />} title='Add Blog' open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                            <div className='row p-3'>

                                {blogs && blogs.filter((el)=>el.isApprove === 1).map((b) =>
                                (
                                    <div className="col-md-4 p-2">
                                        <Paper elevation={3}>
                                            <div>
                                                <img src={`${process.env.REACT_APP_BACKEND}blogs/cover/${b.cover}`} className='col-12' alt={b.slug} />
                                            </div>
                                            <div className='m-2 p-2'>

                                                <div>
                                                    <small> <CalendarMonthIcon fontSize='small' /> {b.date}</small>
                                                </div>
                                                <div>
                                                    <Link to={`https://blogs.cpmsc.com/blog/${b.slug}`}><b> {b.title} </b></Link>
                                                    {/* <Link to={`/blogs/${b.slug}`}><b> {b.title} </b></Link>  */}
                                                </div>
                                                <div className='my-2'>
                                                    <small>
                                                        {htmlToFormattedText(b.details).slice(0, 200)} ...
                                                        <Link to={`https://blogs.cpmsc.com/blog/${b.slug}`}>Read more..</Link>
                                                    </small>
                                                </div>
                                                <div>

                                                </div>
                                            </div>
                                        </Paper>
                                    </div>
                                ))}

                            </div>
                        </Paper>

                    </div>



                    <div className="col-md-4">
                        <Paper elevation={3}>
                            <div className='p-3'>
                                <div>
                                    <Button variant='contained' fullWidth>
                                        Our Schools
                                    </Button>

                                    {schools && schools.map((s) => (
                                        <div className='m-1'>
                                            <Button size='small' onClick={() => navigate(`/school/${s.slug}/${s.slug}`)} variant='outlined'>
                                                {s.schoolName}
                                            </Button>
                                        </div>
                                    ))}
                                </div>
                                <div className='mt-5'>
                                    <Button variant='contained' fullWidth>
                                        Our Courses
                                    </Button>

                                    {courses && courses.map((s) => (
                                        <div className='m-1'>
                                            <Button size='small' onClick={() => navigate(`/course/${s.shortName}`)} variant='outlined'>
                                                {s.courseName}
                                            </Button>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </Paper>

                    </div>
                </div>

            </div>
        </>
    )
}

export default Blogs;